import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TransactionType } from '@shared/helpers/enums/transaction-type';

import { interval, map, Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'gstar-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent {
  private readonly router = inject(Router);

  currentDate$: Observable<Date> = interval(1000).pipe(map(() => new Date()));

  transactionTypes = TransactionType;

  addSecurities(transactionType: TransactionType): void {
    if (transactionType === TransactionType.GeneralRates) {
      this.router.navigate(['/portfolio/add-general-rates']);
    } else {
      this.router.navigate(['/portfolio/add-specific-advice']);
    }
  }

  viewSecurities(transactionType: TransactionType): void {
    this.router.navigate(['portfolio'], {
      queryParams: { transactionType },
    });
  }
}
